import { isEqual } from 'lodash';
import { SimpleState } from 'router5/types/types/base';
import { MiddlewareFactory, Router } from 'router5/types/types/router';

import { getProject } from '@neptune/projects-domain';
import { makeProjectIdentifier } from '@neptune/shared/core-project-util';
import { RouterState } from '@neptune/shared/routing-domain';

import { getOrganizationsList } from 'state/selectors';

export const caseInsensitiveProjectRouteMW: MiddlewareFactory =
  (_: Router, dependencies) => async (toState: RouterState, fromState: RouterState | null) => {
    // we want to run this logic only if it is direct URL navigation
    if (fromState === null) {
      const { params } = toState;

      if (params == null) {
        return;
      }

      const { organizationName, projectName } = params;

      if (organizationName != null) {
        // verify in app state the real name of the organization
        const store = dependencies.store;
        const organization = getOrganizationsList(store.getState()).find(
          (org: { name: string }) => org.name.toLowerCase() === organizationName.toLowerCase(),
        );

        let project;

        if (projectName != null) {
          try {
            project = await getProject(makeProjectIdentifier(organizationName, projectName));
          } catch {
            /** no information about project, so we can't modify the target state / URL */
          }
        }

        const params = { ...toState.params };

        if (organization != null && organization.name !== organizationName) {
          params.organizationName = organization.name;
        }

        if (project != null && project.name !== projectName) {
          params.projectName = project.name;
        }

        if (!isEqual(params, toState.params)) {
          const newState: SimpleState = {
            name: toState.name,
            params,
          };

          return Promise.reject({ redirect: newState });
        }

        return;
      }
    }
  };
